import Axios from 'axios'
import * as API from '@/endpoints'
import Cons from '@/constants.json'

export default {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    setData (state, payload) {
      state.data = payload
    }
  },
  actions: {
    getFaq ({commit}) { 
      return Axios.get(`${API.endpoints.base}/careplan/${Cons[0].GROUP_ID.faqs}/item`).then(
        ({data}) => {
          commit('setData', data.careplan_item)
        })
    }
  }
}
